// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1_FOr","header":"ReportDetails_header__2Yajo","title":"ReportDetails_title__1sq_r","left":"ReportDetails_left__3ODlI"};